<template>
  <a-card class="m-t-10" :bordered="false">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">{{$route.query.id ? '编辑':'新增'}}会员卡</span>
  </a-card>
  <a-card :bordered="false">
    <app-warp title='会员卡'>
      <template #app-content>
        <div style="position: relative;" @scroll="scrollContent">
          <div class="p-8" data-module='search' draggable>
            <div class="app-user-card" :style="{'background':form.background_map.indexOf('linear-gradient')!==-1 ? form.background_map:('url('+info.picdomain+form.background_map+') center center/cover no-repeat')}">
              <div class="app-card-heard">
                <span class="app-card-name">{{info.overView.brand_name}}</span>
                <img :src='info.picdomain+"/"+info.overView.brand_logo' style="width:auto" alt="" />
              </div>
              <div class="app-card-foot">
                <div class="app-card-foot-left">
                  <img :src="upLogo ? info.picdomain+form.vip_icon:require('@/assets/images/user/v'+img_number+'.png')" alt="" />
                  <span class="app-card-leve">{{form.vip_name}}</span>
                </div>
                <div class="s_cfff fz-14">成长值：{{form.vip_exp || 0}}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #app-sider>
        <a-form :model="form" ref='ruleForm' :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" style="margin-left:70px">
          <a-tabs v-model:activeKey="activeKey">
            <a-tab-pane key="1" tab="等级设置">
              <a-divider type="vertical" />
              <a-form-item label="等级名称" name='vip_name' help='最多8个字' :rules="[{ required: true, message: '请输入等级名称' }]">
                <a-input v-model:value="form.vip_name" placeholder='请输入等级名称' :maxlength='8' style="width:200px" />
              </a-form-item>
              <a-form-item label="会员卡背景" name='background_map'>
                <a-radio-group v-model:value="form.is_upload">
                  <a-radio :value="0"> 默认样式 </a-radio>
                  <a-radio :value="1"> 图片 </a-radio>
                </a-radio-group>
                <br />
                <div class="normal_map" v-if="form.is_upload == 0">
                  <ul>
                    <li>
                      <input id="yellow" type="radio" v-model="form.background_map" value="#D8D8D8 linear-gradient(315deg, rgba(252, 219, 161, 0.5) 0%, rgba(208, 126, 35, 0.5) 100%)" hidden />
                      <label for="yellow" :style="{'background':'#D8D8D8 linear-gradient(315deg, rgba(252, 219, 161, 0.5) 0%, rgba(208, 126, 35, 0.5) 100%)'}">
                      </label>
                    </li>
                    <li>
                      <input id="pink" type="radio" v-model="form.background_map" value="#D8D8D8 linear-gradient(315deg, rgba(252, 176, 161, 0.5) 0%, rgba(208, 37, 35, 0.5) 100%)" hidden />
                      <label for="pink" :style="{'background':'#D8D8D8 linear-gradient(315deg, rgba(252, 176, 161, 0.5) 0%, rgba(208, 37, 35, 0.5) 100%)'}">
                      </label>
                    </li>
                    <li>
                      <input type="radio" id="lightPink" v-model="form.background_map" value="#D8D8D8 linear-gradient(135deg, #DE2B07 0%, #FF8C8B 100%)" hidden />
                      <label for="lightPink" :style="{'background':'#D8D8D8 linear-gradient(135deg, #DE2B07 0%, #FF8C8B 100%)'}">
                      </label>
                    </li>
                    <li>
                      <input type="radio" id="blue" v-model="form.background_map" value="#D8D8D8 linear-gradient(135deg, #0736DE 0%, #8B9DFF 100%)" hidden />
                      <label for="blue" :style="{'background':'#D8D8D8 linear-gradient(135deg, #0736DE 0%, #8B9DFF 100%)'}">
                      </label>
                    </li>
                    <li>
                      <input type="radio" v-model="form.background_map" id="Lightblue" value="#D8D8D8 linear-gradient(135deg, #076FDE 0%, #8BE4FF 100%)" hidden />
                      <label for="Lightblue" :style="{'background':'#D8D8D8 linear-gradient(135deg, #076FDE 0%, #8BE4FF 100%)'}">
                      </label>
                    </li>
                    <li>
                      <input type="radio" v-model="form.background_map" id="Lightgreen" value="#D8D8D8 linear-gradient(135deg, #07DEAF 0%, #8BFFFA 100%)" hidden />
                      <label for="Lightgreen" :style="{'background':'#D8D8D8 linear-gradient(135deg, #07DEAF 0%, #8BFFFA 100%)'}">
                      </label>

                    </li>
                    <li>
                      <input type="radio" class="" v-model="form.background_map" id="purple" value='#D8D8D8 linear-gradient(135deg, #8607DE 0%, #B9A7FF 100%)' hidden />
                      <label for="purple" :style="{'background':'#D8D8D8 linear-gradient(135deg, #8607DE 0%, #B9A7FF 100%)'}">
                      </label>
                    </li>
                    <li>
                      <input type="radio" class="" v-model="form.background_map" id="Lightpurple" value="#D8D8D8 linear-gradient(135deg, #DE07CF 0%, #C68BFF 100%)" hidden />
                      <label for="Lightpurple" :style="{'background':'#D8D8D8 linear-gradient(135deg, #DE07CF 0%, #C68BFF 100%)'}">
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="img_map" v-if="form.is_upload==1">
                  <div class="width-107 height-107 s_ovber">
                    <material :image="form.background" :groupType='1' :max="1" ref='imageChoose' v-on:handlechoose="handleChoose" v-on:handledel="(data)=>{form.background_map='#D8D8D8 linear-gradient(315deg, rgba(252, 219, 161, 0.5) 0%, rgba(208, 126, 35, 0.5) 100%)';form.background=''}" />
                  </div>
                </div>
              </a-form-item>
              <a-form-item label="当前会员等级" name='vip_number' v-if='form.vip_number'>
                <p>{{form.vip_number+1}}级</p>
              </a-form-item>
              <a-form-item label="等级图标" help='建议上传正方形比例“png”格式的图片'>
                <div class="width-107 height-107 s_ovber">
                  <material :image="upLogo ? form.vip_icon :''" :groupType='1' :max="1" ref='vip_icon' v-on:handlechoose="(data)=>{form.vip_icon=data;upLogo=true}" v-on:handledel="(data)=>{form.vip_icon='';upLogo=false}" />
                </div>
              </a-form-item>
              <a-form-item label="需成长值达" name='vip_exp' help="仅限整数，成长值不支持修改，请谨慎操作" :rules="[{ required: true, message: '请设置成长值' }]">
                <a-input-number v-model:value="form.vip_exp" :disabled="$route.query.type !== 'add'" class='m-r-10' :min='1' :precision='0' />
                <router-link :to="{path:'/customer/user/userSet', query:{active:'4'}}" v-if="$route.query.type == 'add'" target="_blank">成长值设置
                </router-link>
              </a-form-item>
         
            </a-tab-pane>
            <a-tab-pane key="2" tab="特权设置">
              <a-form-item label="" :wrapper-col="{ span: 20, offset: 2 }">
                <div class="m-b-20">
                  <a-checkbox v-model:checked="form.privileges.is_birthday" @change='form.privileges.is_birthday = form.privileges.is_birthday?1:0'>
                    生日礼包
                  </a-checkbox>
                  <div class='p-l-30 s_bf7 p-t-20 p-b-20 m-t-10' v-if='form.privileges.is_birthday'>
                    <div class="s_flex_ali">
                      <a-checkbox v-model:checked="form.privileges.is_birthday_point" @change='form.privileges.is_birthday_point = form.privileges.is_birthday_point?1:0'>
                      </a-checkbox>
                      <span class="m-l-10" style="display: inline-block;width: 75px;">送积分</span>
                      <a-input-number style="width:200px" v-model:value="form.privileges.birthday_point_count" :min="0" :precision='0' :disabled="!form.privileges.is_birthday_point" /> <span class="m-l-20">积分</span>
                    </div>
                    <!--  -->
                    <div class="s_flex_ali m-t-15">
                      <a-checkbox v-model:checked="form.privileges.is_red_envelopes" @change='form.privileges.is_red_envelopes = form.privileges.is_red_envelopes?1:0'></a-checkbox>
                      <span class="m-l-10" style="display: inline-block;width: 75px;">送红包</span>
                      <a-input v-model:value="form.privileges.red_envelopes_text" readonly :disabled="!form.privileges.is_red_envelopes" style="width:200px" />
                      <a-button type="primary" class="m-l-20" v-show="form.privileges.is_red_envelopes" @click="openTable(1)">选择</a-button>
                    </div>
                    <div class="s_flex_ali m-t-15">
                      <a-checkbox v-model:checked="form.privileges.is_coupons" @change='form.privileges.is_coupons = form.privileges.is_coupons?1:0'></a-checkbox>
                      <span class="m-l-10" style="display: inline-block;width: 75px;">派券</span>
                      <a-input v-model:value="form.privileges.coupons_value" readonly :disabled="!form.privileges.is_coupons" style="width:200px" />
                      <a-button type="primary" class="m-l-20" v-show="form.privileges.is_coupons" @click="openTable(2)">选择</a-button>
                    </div>
                    <!-- 送礼品开始 --> 
                    <div class="s_flex_ali m-t-15">
                      <a-checkbox v-model:checked="form.privileges.is_birthday_gift" @change='form.privileges.is_birthday_gift = form.privileges.is_birthday_gift?1:0'></a-checkbox>
                      <span class="m-l-10" style="display: inline-block;width: 75px;">礼品</span>
                      <a-input v-model:value="form.privileges.birthday_gift_name" readonly :disabled="!form.privileges.is_birthday_gift" style="width:200px" />
                      <a-button type="primary" class="m-l-20" v-show="form.privileges.is_birthday_gift" @click="showGift=true">选择</a-button>
                    </div>
                    <div class="s_flex_ali">
                      <div class="width-75 m-l-25 height-10"> </div>
                      <div>过期时间：领取后 <a-input-number v-model:value="form.privileges.birthday_gift_overtime" :precision="0" :min="1"></a-input-number>小时过期</div>
                    </div>
                    <!-- 送礼品结束 -->
                    <!--  -->
                    <div class="s_flex_ali m-t-20">
                      <div class="m-r-28 s_fonts16">祝福文案</div>
                      <a-button type="primary" class="m-l-20" @click="showWish=true">文案配置</a-button>
                    </div>
                    <div class="m-t-5 s_c999 fz-14">设置会员生日时系统弹窗的生日祝福文案</div>
                  </div>
                </div>
                <!-- <div class="m-b-20">
                  <a-checkbox v-model:checked="form.privileges.is_free_shipping"
                    @change='form.privileges.is_free_shipping = form.privileges.is_free_shipping?1:0'>免邮特权</a-checkbox>
                  <div class='p-l-30 p-l-30 s_bf7 p-t-20 p-b-20 m-t-10' v-if='form.privileges.is_free_shipping'>
                    <a-form-item label="每月可领取" name='free_shipping_count'>
                      <a-input-number v-model:value="form.privileges.free_shipping_count" style="width:145px;" :precision='0'
                        :disabled="!form.privileges.is_free_shipping" />
                      <span class='p-l-10'>张<span class='s_font_b s_c000'> 包邮卡</span>（全国包邮）</span>
                    </a-form-item>
                    <a-form-item label="包邮卡有效时长">
                      <a-input-number v-model:value="form.privileges.valid_day" :min="1" :max="90" style="width:145px;" :precision='0'
                        :disabled="!form.privileges.is_free_shipping" />
                      <span class='p-l-10'><span class='s_font_b'>天</span>（最多90天，自领取之日起N天有效期）</span>
                    </a-form-item>
                  </div>
                </div> -->
                <div class="m-b-20">
                  <a-checkbox v-model:checked="form.privileges.is_shopping_discount" @change='form.privileges.is_shopping_discount = form.privileges.is_shopping_discount?1:0'>折扣特权</a-checkbox>
                  <div class='p-l-30 p-l-30 s_bf7 p-t-20 p-b-20 m-t-10' v-if='form.privileges.is_shopping_discount'>
                    <a-form-item label="会员购买商品享" name='shopping_discount' style="margin-bottom: 0;">
                      <a-input-number v-model:value="form.privileges.shopping_discount" style="width:200px;" :min='0.1' :max='9.9' :precision='1' :disabled="!form.privileges.is_shopping_discount" />
                      <span class='p-l-10 fz-9'>折</span>
                    </a-form-item>
                    <p class="s_c999 s_lin_h24 p-r-20 m-t-10">需要前往 <a href="javascript:;" @click='openSet'>直播云店-活动管理-会员专享商品</a> 设置会员专享商品。如同一商品既参与了其他营销活动，又符合会员专享价时，以最优惠的价格为准</p>
                  </div>
                </div>
                <div class="m-b-20">
                  <a-checkbox v-model:checked="form.privileges.is_exclusive" @change='form.privileges.is_exclusive = form.privileges.is_exclusive?1:0'>
                    产品特权
                  </a-checkbox>
                  <div class='p-l-10 s_bf7 p-t-20 p-b-20 m-t-10' v-if='form.privileges.is_exclusive'>
                    <div>
                      <a-checkbox v-model:checked="form.privileges.is_share" @change='form.privileges.is_share = form.privileges.is_share?1:0'>
                        分享特权（用于用户间的拉新操作，每个新用户只能领取一个商品）
                      </a-checkbox>
                    </div>
                    <div class="p-l-30 m-b-30 p-r-20" v-if='form.privileges.is_share'>
                      <!-- <div class="s_flex_ali">
                        <p class="width-120">领取用户</p>
                        <a-radio-group v-model:value="form.privileges.share_receive_member">
                          <a-radio :value="1"> 不限 </a-radio>
                          <a-radio :value="2"> 已绑定用户 </a-radio>
                          <a-radio :value="3"> 未绑定用户 </a-radio>
                        </a-radio-group>
                      </div> -->
                      <a-form-item name='share_receive_type' style="margin-bottom: 0;" help="（门店自提订单可在订单-订单设置中配置）">
                        <div class="s_flex_ali">
                          <p class="width-120">领取方式</p>
                          <a-checkbox-group v-model:value="form.privileges.share_receive_type">
                            <a-checkbox :value="1">总部配送</a-checkbox>
                            <a-checkbox :value="2" :disabled="true">门店自提</a-checkbox>
                          </a-checkbox-group>
                        </div>
                      </a-form-item>
                      <div class="s_flex_ali">
                        <p class="width-120">领取有效期</p>
                        <a-select v-model:value="form.privileges.share_receive_time" placeholder="请选择" style="width:200px;">
                          <a-select-option v-for='item in dayList' :key='item' :value="item">{{item}}</a-select-option>
                        </a-select>
                        <span class="p-l-10">天</span>
                      </div>
                      <div class="s_flex_ali">
                        <p class="width-120">权益周期</p>
                        <a-radio-group v-model:value="form.privileges.share_cycle">
                          <a-radio :value="1"> 仅一次 </a-radio>
                          <a-radio :value="2"> 每月一次 </a-radio>
                          <a-radio :value="3"> 每季度一次 </a-radio>
                        </a-radio-group>
                      </div>
                      <p class="s_c999">每月一次按自然月作为周期，每季度一次按自然季度作为周期，成功修改分享周期，重置用户分享次数</p>
                      <div class="s_flex_ali">
                        <p class="width-120">每个产品可分享</p>
                        <a-input-number v-model:value="form.privileges.share_number" :min="1" :max='10' style="width:200px" :precision='0' placeholder='产品可分享次数最大值为10' />
                        <span class="m-l-20">次</span>
                      </div>
                      <a-form-item name='share_product_id' style='margin-bottom: 0;'>
                        <div class="s_flex_ali">
                          <p class="width-120">产品</p>
                          <a-button type="primary" @click='selectOpen("share")'>选择</a-button>
                        </div>
                      </a-form-item>
                      <a-table v-if='shareList.length > 0' class="m-t-15 m-b-15" :pagination='false' :loading='listLoading' bordered align="center" rowKey='id' :columns='columns' :data-source='shareList'>
                        <template v-slot:info="{record}">
                          <a-card-meta>
                            <template #avatar>
                              <img :src="info.picdomain+'/'+(record.cover_image_url||record.image)" alt="" style="width:50px">
                            </template>
                            <template #description>{{record.product_name}}</template>
                          </a-card-meta>
                        </template>
                        <template v-slot:action='{index}'>
                          <a-button type="link" @click='delGood(index,"share")'>删除</a-button>
                        </template>
                      </a-table>
                      <a-form-item name='share_delivery_id' style='margin-bottom: 0;'>
                        <div class="s_flex_ali">
                          <p class="width-120">运费设置</p>
                          <a-select v-model:value="form.privileges.share_delivery_id" :style="{width:'200px'}" placeholder="请选择">
                            <a-select-option v-for='(item,index) in freightList' :key="index" :value="item.id">{{item.name}}</a-select-option>
                          </a-select>
                        </div>
                      </a-form-item>
                    </div>
                    <a-checkbox v-model:checked="form.privileges.is_product_exclusive" @change='form.privileges.is_product_exclusive = form.privileges.is_product_exclusive?1:0'>
                      产品品鉴（用于品牌对该等级用户的商品试用特权）
                    </a-checkbox>
                    <div class="p-l-30 p-r-20" v-if='form.privileges.is_product_exclusive'>
                      <a-form-item name='product_receive_type' style='margin-bottom: 0;' help="（门店自提订单可在订单-订单设置中配置）">
                        <div class="s_flex_ali">
                          <p class="width-120">领取方式</p>
                          <a-checkbox-group v-model:value="form.privileges.product_receive_type">
                            <a-checkbox :value="1">总部配送</a-checkbox>
                            <a-checkbox :value="2" :disabled="true">门店自提</a-checkbox>
                          </a-checkbox-group>
                        </div>
                      </a-form-item>
                      <!-- <div class="s_flex_ali">
                        <p class="width-120">领取有效期</p>
                        <a-select style='width:50%;' v-model:value="form.privileges.product_receive_time" placeholder="请选择">
                          <a-select-option v-for='item in dayList' :key='item' :value="item">{{item}}</a-select-option>
                        </a-select>
                        <span class="p-l-10">天</span>
                      </div> -->
                      <div class="s_flex_ali">
                        <p class="width-120">权益周期</p>
                        <a-radio-group v-model:value="form.privileges.product_cycle">
                          <a-radio :value="1"> 仅一次 </a-radio>
                          <a-radio :value="2"> 每月一次 </a-radio>
                          <a-radio :value="3"> 每季度一次 </a-radio>
                        </a-radio-group>
                      </div>
                      <p class="s_c999">每月一次按自然月作为周期，每季度一次按自然季度作为周期，成功修改分享周期，重置用户分享次数</p>
                      <a-form-item name='product_product_id' style='margin-bottom: 0;'>
                        <div class="s_flex_ali">
                          <p class="width-120">产品</p>
                          <a-button type="primary" @click='selectOpen("good")'>选择</a-button>
                        </div>
                      </a-form-item>
                      <a-table v-if='goodList.length > 0' class="m-t-15 m-b-15" :pagination='false' :loading='listLoading' bordered align="center" rowKey='id' :columns='columns' :data-source='goodList'>
                        <template v-slot:info="{record}">
                          <a-card-meta>
                            <template #avatar>
                              <img :src="info.picdomain+'/'+(record.cover_image_url||record.image)" alt="" style="width:50px">
                            </template>
                            <template #description>{{record.product_name}}</template>
                          </a-card-meta>
                        </template>
                        <template v-slot:action="{index}">
                          <a-button type="link" @click='delGood(index,"good")'>删除</a-button>
                        </template>
                      </a-table>
                      <a-form-item name='product_delivery_id' style='margin-bottom: 0;'>
                        <div class="s_flex_ali">
                          <p class="width-120">运费设置</p>
                          <a-select v-model:value="form.privileges.product_delivery_id" :style="{width:'200px'}" placeholder="请选择">
                            <a-select-option v-for='(item,index) in freightList' :key="index" :value="item.id">{{item.name}}</a-select-option>
                          </a-select>
                        </div>
                      </a-form-item>
                    </div>
                  </div>
                </div>
                <div class="m-b-20">
                  <a-checkbox v-model:checked="form.privileges.is_grade_gift" @change='form.privileges.is_grade_gift = form.privileges.is_grade_gift?1:0'>礼品派发</a-checkbox>（用户达到等级后，每个自然月可领取的礼品，不配置该月没有礼品）
                  <div class='p-l-30 p-l-30 s_bf7 p-t-20 p-b-20 m-t-10' v-if="form.privileges.is_grade_gift">
                    <giftSendSeting  v-model:value="gradeGift" :privileges="form.privileges" />
                  </div>
                </div>
                <div class="m-b-20">
                  <a-checkbox v-model:checked="form.privileges.is_scan_code" @change='form.privileges.is_scan_code = form.privileges.is_scan_code?1:0'>
                    扫码特权
                  </a-checkbox>
                  <div class='p-l-30 p-l-30 s_bf7 p-t-20 p-b-20 m-t-10' v-if='form.privileges.is_scan_code'>
                    <div class="s_flex_ali">
                      <a-checkbox v-model:checked="form.privileges.is_point_reward" @change='form.privileges.is_point_reward = form.privileges.is_point_reward?1:0'></a-checkbox>
                      <span class="m-l-10" style="display: inline-block;width: 150px;">扫码奖项中积分翻倍</span>
                      <a-input-number v-model:value="form.privileges.point_reward_num" :min="1" :precision='1' style="width:20%;" :disabled="!form.privileges.is_point_reward" /> <span class="m-l-10">倍</span><span class="s_c999">（在原奖项积分的基础上进行翻倍，不能小于1）</span>
                    </div>
                    <div class="s_flex_ali">
                      <a-checkbox v-model:checked="form.privileges.is_red_reward" @change='form.privileges.is_red_reward = form.privileges.is_red_reward?1:0'>
                      </a-checkbox>
                      <span class="m-l-10" style="display: inline-block;width: 150px;">扫码奖项中红包翻倍</span>
                      <a-input-number v-model:value="form.privileges.red_reward_num" :min="1" :precision='1' style="width:20%;" :disabled="!form.privileges.is_red_reward" /> <span class="m-l-10">倍</span><span class="s_c999">（在原奖项红包的基础上进行翻倍，不能小于1）</span>
                    </div>
                  </div>
                </div>
                <div class="m-b-20">
                  <a-checkbox v-model:checked="form.is_other_privileges" @change='form.is_other_privileges = form.is_other_privileges?1:0'>
                    自定义特权
                  </a-checkbox>
                  <div v-if="form.is_other_privileges">
                    <quill v-model:value="form.other_privileges_text" :content="form.other_privileges_text?JSON.parse(JSON.stringify(form.other_privileges_text)):''" :height="700" style="height:1000px" />
                  </div>
                </div>

              </a-form-item>
            </a-tab-pane>
          </a-tabs>
          <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="" @click="()=>{$router.go(-1)}" class='m-r-20'> 取消 </a-button>
            <a-button type="primary" @click="onSubmit"> 保存 </a-button>
          </a-form-item>
        </a-form>
      </template>
    </app-warp>
  </a-card>
  <a-modal :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <selectGood v-on:select="goodSelect" :selectList='selectList' :checkout="true" :selectLimit='5'></selectGood>
  </a-modal>

  <a-modal :keyboard="false" :title="tableTitle" v-model:visible="showTable" centered :width='1300' :footer="null" destroyOnClose>
    <tableList :tableKey="tableKey" :tableId="tableId" @change="selectItem"></tableList>
  </a-modal>
  <!-- 祝福文案 -->
  <a-modal :keyboard="false" title="文案配置" v-model:visible="showWish" centered :width='1300' :footer="null" destroyOnClose>
    <wishList></wishList>
  </a-modal>
  <!-- 选择礼品 -->
  <a-modal :keyboard="false" title="选择礼品" v-model:visible="showGift" centered :width='1300' :footer="null" destroyOnClose>
    <selectBaseGiftSku :checkout="false" v-on:select="giftSelect" />
  </a-modal>
  <!--  -->
</template>
<script>
import { LeftOutlined } from "@ant-design/icons-vue";
import {
  reactive,
  toRef,
  toRefs,
  watch,
  watchEffect,
  ref,
  inject,
  onMounted,
} from "vue";
import {
  setMemberVip,
  getMemberVipDetail,
  editMemberVip,
  delMemberVip,
} from "@/api/member";
import { getDeliveryList } from "@/api/order";
import { message, Modal } from "ant-design-vue";
import { iscode } from "@/utils/app";
import store from "@/store";
import config from "@/config";
import { getToken } from "@/libs/util";
import tableList from "./components/tableList";
import wishList from "./components/wishList";
import giftSendSeting from "./components/giftSendSeting"; //礼品派发组件
let defForm = {
  vip_name: "",
  is_upload: 0,
  vip_exp: 0,
  vip_icon: "",
  background: "",
  background_map:
    "#D8D8D8 linear-gradient(315deg, rgba(252, 219, 161, 0.5) 0%, rgba(208, 126, 35, 0.5) 100%)",
  instructions:
    "1. 凡成功注册会员的，即可享受多重会员礼遇； \n2. 会员仅限申请者本人使用，会员卡会籍及卡内积分不可转让或出借； \n3. 线上支付直接可识别会员，无须其他操作； \n4. 没有登记会员生日的，无法享受会员生日特权； \n5. 会员生日一旦提交不能修改哦。 ",
  privileges: {
    is_birthday: 0,
    is_birthday_point: 0,
    birthday_point_count: 0,
    is_coupons: 0,
    coupons_id: "",
    coupons_value: "",
    red_envelopes_id: "",
    is_red_envelopes: 0,
    red_envelopes_money: "",
    red_envelopes_text: "",
    is_free_shipping: 0,
    free_shipping_count: 1,
    valid_day: 1,
    is_exclusive: 0,
    is_share: 0,
    share_receive_member: 1,
    share_number: 1,
    share_receive_type: [1],
    share_receive_time: 1,
    share_cycle: 1,
    share_product_id: "",
    share_delivery_id: null,
    is_product_exclusive: 0,
    product_receive_type: [1],
    product_receive_time: 1,
    product_cycle: 1,
    product_product_id: "",
    product_delivery_id: null,
    is_scan_code: 0,
    is_red_reward: 0,
    red_reward_num: "",
    is_point_reward: 0,
    point_reward_num: "",
    is_shopping_discount: 0,
    shopping_discount: 9.9,
    other_privileges_text:"",
    is_other_privileges:0
  },
};
export default {
  components: { LeftOutlined, tableList, wishList, giftSendSeting },
  setup(props) {
    let share_receive_type = async () => {
      if (!form.value.privileges.share_receive_type.length) {
        return Promise.reject("请选择领取方式");
      } else {
        return Promise.resolve();
      }
    };
    let share_product_id = async () => {
      if (!state.shareList.length) {
        return Promise.reject("请选择产品");
      } else {
        return Promise.resolve();
      }
    };
    let share_delivery_id = async () => {
      if (!form.value.privileges.share_delivery_id) {
        return Promise.reject("请选择运费模板");
      } else {
        return Promise.resolve();
      }
    };
    let product_receive_type = async () => {
      if (!form.value.privileges.product_receive_type.length) {
        return Promise.reject("请选择领取方式");
      } else {
        return Promise.resolve();
      }
    };
    let product_product_id = async () => {
      if (!state.goodList.length) {
        return Promise.reject("请选择产品");
      } else {
        return Promise.resolve();
      }
    };
    let product_delivery_id = async () => {
      if (!form.value.privileges.product_delivery_id) {
        return Promise.reject("请选择运费模板");
      } else {
        return Promise.resolve();
      }
    };
    const form = ref({ ...defForm });
    const state = reactive({
      gradeGift:{},//礼品派发数据
      showGift: false, //选择礼品弹窗
      upLogo: false,
      img_number: 1,
      dayList: [],
      linkVisible: false,
      showGood: false,
      goodList: [],
      shareList: [],
      selectList: [],
      selectType: "",
      freightList: [],
      activeKey: "1",
      info: store.state.user.info,
      showTable: false,
      tableTitle: "选择红包",
      tableKey: 1,
      tableId: "",
      showWish: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      rules: {
        share_receive_type: [{ required: true, validator: share_receive_type }],
        share_product_id: [{ required: true, validator: share_product_id }],
        share_delivery_id: [{ required: true, validator: share_delivery_id }],
        product_receive_type: [
          { required: true, validator: product_receive_type },
        ],
        product_product_id: [{ required: true, validator: product_product_id }],
        product_delivery_id: [
          { required: true, validator: product_delivery_id },
        ],
      },
    });
    const columns = [
      //table头
      {
        title: "商品ID",
        dataIndex: "id",
        key: "id",
        width: 80,
      },
      {
        title: "商品信息",
        dataIndex: "info",
        key: "info",
        slots: { customRender: "info" },
      },
      {
        title: "售价",
        dataIndex: "product_price",
        key: "product_price",
        align: "center",
      },
      {
        title: "操作",
        key: "action",
        width: 140,
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $route = inject("$route");
    onMounted(async () => {
      if ($route.query.id) {
        let res = getMemberVipDetail($route.query.id)
          .then((res) => {
            form.value = res.data.data;
            form.value.background = res.data.data.background_map;
            if (form.value.vip_icon.length == 6) {
              state.upLogo = false;
            } else {
              state.upLogo = true;
            }
            state.img_number = form.value.vip_number + 1;
            state.shareList = res.data.data.share_product;
            state.goodList = res.data.data.product_product;
          })
          .catch((error) => error);
      }
      getFreight();
      state.dayList = [...Array(30)].map((k, i) => i + 1);
    });
    // 获取运费模板
    const getFreight = async () => {
      let res = await getDeliveryList({ page: 1, limit: 99 }).then(
        (res) => res.data
      );
      if (iscode(res)) {
        state.freightList = res.data.data;
        if (!form.value.privileges.product_delivery_id) {
          form.value.privileges.product_delivery_id = res.data.data[0].id;
        }
        if (!form.value.privileges.share_delivery_id) {
          form.value.privileges.share_delivery_id = res.data.data[0].id;
        }
      } else {
        message.error(res.msg);
      }
    };
    const handleChoose = (data) => {
      form.value.background_map = data;
      form.value.background = data;
    };
    // 跳转直播云店
    const openSet = () => {
      var url =
        config.cloudUrl[process.env.VUE_APP_type] +
        "activity/activityDiscount?picdomain=" +
        store.state.user.info.picdomain +
        "&token=" +
        getToken()+'&brand_mark='+store.state.user.info.brand_mark;
      window.open(url);
    };
    //打开选择产品
    const selectOpen = (e) => {
      if (e == "share") {
        state.selectList = state.shareList;
      } else {
        state.selectList = state.goodList;
      }
      if (state.selectList.length >= 5) {
        message.error("最多关联5个商品!");
        return;
      }
      state.selectType = e;
      state.showGood = true;
    };
    //选择商品
    const goodSelect = (e) => {
      if (state.selectType == "share") {
        state.shareList = e;
      } else {
        state.goodList = e;
      }
      state.showGood = false;
    };
    //删除商品
    const delGood = (e, text) => {
      console.log(e);
      if (text == "share") {
        state.shareList.splice(e, 1);
      } else {
        state.goodList.splice(e, 1);
      }
    };
    // 保存
    const ruleForm = ref();
    const _lodash = inject("_lodash");
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(() => {
          Modal.confirm({
            title: "确定生成会员卡?",
            centered: true,
            content: "确定后成长值不可修改",
            onOk: () => {
              onConfirm();
            },
          });
        })
        .catch((error) => {});
    };
    const onConfirm = async () => {
      var background_map = form.value.background_map;
      if (form.value.is_upload == 1) {
        if (!form.value.background) {
          message.error("请选择背景图");
          return;
        } else {
          background_map = form.value.background;
        }
      }
      if (state.shareList.length) {
        form.value.privileges.share_product_id = [];
        form.value.privileges.share_product_id = _lodash.map(
          state.shareList,
          "id"
        );
      }
      if (state.goodList.length) {
        form.value.privileges.product_product_id = [];
        form.value.privileges.product_product_id = _lodash.map(
          state.goodList,
          "id"
        );
      }
      form.value.privileges.share_delivery_id = form.value.privileges
        .share_delivery_id
        ? form.value.privileges.share_delivery_id
        : state.freightList[0].id;
      form.value.privileges.product_delivery_id = form.value.privileges
        .product_delivery_id
        ? form.value.privileges.product_delivery_id
        : state.freightList[0].id;
      let result;
      
      form.value.privileges=Object.assign(form.value.privileges,state.gradeGift)
      console.log(form.value.privileges)
      if ($route.query.id) {
        result = await editMemberVip($route.query.id, {
          ...form.value,
          background_map: background_map,
        })
          .then((res) => res.data)
          .catch((error) => error);
      } else {
        result = await setMemberVip({
          ...form.value,

          background_map: background_map,
        })
          .then((res) => res.data)
          .catch((error) => error);
      }
      if (iscode(result)) {
        message.success(result.msg);
        setTimeout(() => {
          $router.go(-1);
        }, 2000);
      } else {
        message.error(result.msg);
      }
    };
    //打开
    const openTable = function (val) {
      if (val == 1) {
        //红包
        state.tableTitle = "选择红包";
        state.tableKey = 1;
        state.tableId = form.value.privileges.red_envelopes_money;
      } else {
        //优惠券
        state.tableTitle = "选择优惠券";
        state.tableKey = 2;
        state.tableId = form.value.privileges.coupons_id;
      }
      state.showTable = true;
    };

    //关闭
    const selectItem = function (data) {
      console.log(data);
      state.tableId = data.id || "";
      if (state.tableKey == 1) {
        form.value.privileges.red_envelopes_text = +data.amount;
        form.value.privileges.red_envelopes_money = data.id;
      } else {
        form.value.privileges.coupons_value = data.name;
        form.value.privileges.coupons_id = data.id;
      }
      state.showTable = false;
    };
    // 选择礼品完毕
    const giftSelect = (data) => {
      form.value.privileges.birthday_gift_id=data.gift_id
      form.value.privileges.birthday_gift_sku=data.sku_number
      form.value.privileges.birthday_gift_name=data.gift_name
      console.log(data,form.value);
      state.showGift = false;
    };
    return {
      ...toRefs(state),
      columns,
      form,
      ruleForm,
      onSubmit,
      selectOpen,
      goodSelect,
      handleChoose,
      delGood,
      openSet,
      onConfirm,
      openTable,
      selectItem,
      giftSelect,
    };
  },
};
</script>
<style lang="less" scoped>
@import url("@/style/app-warp/app-warp.less");
.normal_map {
  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      margin-right: 10px;
      margin-bottom: 10px;
      label {
        width: 57px;
        height: 57px;
        display: block;
        border: 1px solid transparent;
      }

      input:checked ~ label {
        border: 1px solid #05486a;
      }
    }
  }
}
</style>